import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const SCAN_WITH_EXISTING_REQUESTER =
  "SCAN_WITH_EXISTING_REQUESTER";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Ocr/ScanWithExistingRequester`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SCAN_WITH_EXISTING_REQUESTER, service, mock);
